// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"CheckBox_checkBoxContainer__yV6Pe"};